<template>
  <div>
    <div class="invoice-basic">
      <div class="train">
        <div>
          <p>发票号码</p>
          <p>开票日期</p>
          <p>{{invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo}}</p>
          <p>{{invoiceInfo.drewDate || invoiceInfo.ocrDrewDate}}</p>
        </div>
        <div>
            <p>出发站</p>
            <p></p>
            <p>车次</p>
            <p></p>
            <p>到达站</p>
            <p>{{invoiceInfo.stationGetOn}}</p>
            <p>{{invoiceInfo.trainNumber}}</p>
            <p>{{invoiceInfo.stationGetOff}}</p>
        </div>
      </div>
      <div class="divider-custom"></div>
      <van-cell-group v-show="invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax" :border="false">
        <van-field
          label="发票金额"
        >
          <p slot="input" class="input" style="color: #2196F3;font-weight:bold">{{invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.passengerName" :border="false">
        <van-field
          label="乘客姓名"
        >
          <p slot="input" class="input">{{invoiceInfo.passengerName}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.getOnDate" :border="false">
        <van-field
          label="乘车日期"
        >
          <p slot="input" class="input">{{invoiceInfo.getOnDate}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.seat" :border="false">
        <van-field
          label="座位类型"
        >
          <p slot="input" class="input">{{invoiceInfo.seat}}</p>
        </van-field>
      </van-cell-group>
    </div>
    <div class="divider-custom"></div>
    <van-cell-group :border="false">
      <van-field
        label="备注"
      >
        <div slot="input" class="input">{{invoiceInfo.remark}}</div>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="标签"
      >
        <div slot="input" class="input">{{invoiceInfo.tag}}</div>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import {
  CellGroup,
  Field,
  Divider
} from 'vant'
import { ConvertNumber } from '@utils/basicUtil'
export default {
  props: {
    invoiceInfo: {
      type: Object
    }
  },
  mounted () {
  },
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    }
  },
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
